import React from "react";
/* ===========================
   Common Reusable Table
=========================== */
const CommonTable = ({ columns, data, compareEditable, compareUserList, selectCompareRow, renderActions }) => {
  return (
    <div className="w-full overflow-x-auto">
      <table className="w-full">
        <thead className="bg-gray-100 border-b">
          <tr>
            {compareEditable &&
              <th className="px-4 py-3 text-left text-sm font-semibold textblack transition-all duration-300 ease-in-out
      opacity-100 translate-y-0"  >
                {"Compare"}
              </th>
            }

            {columns.map((col) => (
              <th
                key={col.key}
                className="px-4 py-3 text-left text-sm font-semibold textblack"
              >
                {col.label}
              </th>
            ))}


            {renderActions && (
              <th className="px-4 py-3 text-sm font-semibold textblack text-left">
                Action
              </th>
            )}
          </tr>
        </thead>

        <tbody>
          {data.map((row, index) => (
            <tr
              key={index}
              className="border-b last:border-none hover:bg-gray-50"
            >

              {compareEditable &&
                <td className="px-4 py-4 transition-all duration-300 ease-in-out
      opacity-100 translate-y-0">
                  <input
                    type="checkbox"
                    checked={compareUserList.some(prev => prev.userId === row.userId)}
                    onChange={() => selectCompareRow(row)}
                  />
                </td>
              }
              {columns.map((col) => (
                <td key={col.key} className="px-4 py-4 text-sm text-[#111827]">
                  {col.key === "status" ? (
                    <div
                      className={`px-4 w-28 mx-auto text-center py-2 rounded-md text-sm inline-block whitespace-nowrap
                                    ${row[col.key] === "Completed"
                          ? "bg-[#E0F2F1] textcolor"
                          : "border border-[#D1D5DB] textblack"
                        }`}
                    >
                      {row[col.key]}
                    </div>
                  ) : (
                    col.key === "themes" ?
                      <>
                        <span className="font-medium textcolor flex flex-wrap gap-2">
                          {row[col.key] && row[col.key].length > 0 ? row[col.key].map((item, index) => (
                            <span
                              key={index}
                              className="px-2 py-1 rounded-full text-xs font-medium"
                              style={{
                                color: item.colorcode,
                                backgroundColor: item.bgcolor,
                              }}
                            >
                              {item.name}
                            </span>
                          )) :
                            <span
                              className="px-2 py-1 rounded-full text-sm text-gray-400"
                            >
                              {"Not Available"}
                            </span>}
                        </span>
                      </>
                      :
                      col.key === "name" ?
                        <>
                          <div className="flex items-center gap-3">
                            <div className="w-8 h-8 rounded-full bg-gray-100 text-gray-600 flex items-center justify-center font-semibold">
                              {row[col.key].charAt(0).toUpperCase()}
                            </div>
                            <div>
                              <p className="font-medium capitalize">{row[col.key]}</p>
                              {/* <p className="text-xs text-gray-500">
                                Primary: Coach
                              </p> */}
                            </div>
                          </div>
                        </> : row[col.key]
                  )}
                </td>
              ))}

              {renderActions && (
                <td className="px-4 py-2">
                  {renderActions(row)}
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
export default CommonTable;
